/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable import/no-anonymous-default-export */
import React, { useState, useEffect } from "react";
import { SessionKeys } from "../utils/AppUtils";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { userDetailBroker } from "../redux/user/actions";
import { useTranslation } from "react-i18next";

export default function (props) {
  const { isMobile, isLoading, setIsLoading } = props;

  let dispatch = useDispatch();
  const { t } = useTranslation();
  const userRole = useSelector((state) => state.user.role);
  const userDetailRes = useSelector((state) => state.user.userBroker);

  // useEffect(() => {
  //   dispatch(
  //     userDetailBroker({
  //       module: "getOrderDetailBroker",
  //       apiToken: isMobile
  //         ? localStorage.getItem(SessionKeys.API_TOKEN)
  //         : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
  //     })
  //   );
  // }, []);

  const [iframePodcast, setIframePodcast] = useState("");
  const [iframeFB, setIframeFB] = useState("");
  const [iframeLinkdin, setIframeLinkdin] = useState("");

  useEffect(() => {
    if (!_.isEmpty(userDetailRes)) {
      if (userDetailRes.status === "success") {
        console.log("userDetailRes111111111: ", userDetailRes);

        setIframePodcast(userDetailRes?.payload?.payload?.youtube_ifram);
        setIframeFB(userDetailRes?.payload?.payload?.facebook_feed);
        setIframeLinkdin(userDetailRes?.payload?.payload?.linkedin_feed);
      }
      // setIsLoading(false)
    }
  }, [userDetailRes]);

  return (
    <div>
      <div className={`ifrma-section ${isMobile ? "" : ""} pt-5g pb-5`}>
        <div className=" container">
          {(!_.isEmpty(iframePodcast) ||
            !_.isEmpty(iframeFB) ||
            !_.isEmpty(iframeLinkdin)) &&
            !isMobile && (
              <div className="search_heading mb-3">
                <p className="lable-heading_search">{t("Market Updates")}</p>
              </div>
            )}
          <div className="row">
            {!_.isEmpty(iframePodcast) && (
              <div className="col-md-12 col-xl-6">
                <div className="d-flex My_Dashboardwall-frame">
                  <h4 className="mb-4">{t("Podcasts Feed")}</h4>
                </div>
                <div
                  className="iframe-widht"
                  dangerouslySetInnerHTML={{ __html: iframePodcast }}
                ></div>
                {false && (
                  <iframe
                    id="fb-1"
                    allow="autoplay *; encrypted-media *; fullscreen *; clipboard-write"
                    frameborder="0"
                    height="175"
                    style={{ width: "100%" }}
                    sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation"
                    src="https://embed.podcasts.apple.com/ca/podcast/the-realtors-who-will-thrive-in-a-chatgpt-future/id1465098759?i=1000643538587"
                  ></iframe>
                )}
              </div>
            )}
            {!_.isEmpty(iframeFB) && (
              <div className="col-md-12 col-xl-6">
                <div className="d-flex My_Dashboardwall-frame">
                  <h4 className="mb-4">{t("Facebook Feed")}</h4>
                </div>
                <div
                  className="iframe-widht"
                  dangerouslySetInnerHTML={{ __html: iframeFB }}
                ></div>
              </div>
            )}
          </div>
          <div className="row">
            {!_.isEmpty(iframeLinkdin) && (
              <div className="col-md-12 col-xl-6">
                <div className="d-flex My_Dashboardwall-frame">
                  <h4 className="mb-4">{t("LinkedIn Feed")}</h4>
                </div>
                <div
                  className="iframe-widht"
                  dangerouslySetInnerHTML={{ __html: iframeLinkdin }}
                ></div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
